module.exports = __webpack_public_path__ + "img/36645-134.8859729c.jpg";